import generatePicker from 'antd/es/date-picker/generatePicker'
import type { GenerateConfig } from 'rc-picker/es/generate'
import dayjsGenerateConfig from 'rc-picker/es/generate/dayjs'

import { date, type Dayjs } from 'configuration/dayjs'

// antd builds every date it creates (today, parsed input text) from a local-time
// dayjs. Re-anchoring those in UTC keeps picked values on the same instants as the
// rest of the app. Values passed in keep their own zone, so a .tz() value shows
// that zone's calendar day.
export const utcGenerateConfig: GenerateConfig<Dayjs> = {
    ...dayjsGenerateConfig,
    getNow: () => date(),
    getFixedDate: (fixed) => dayjsGenerateConfig.getFixedDate(fixed).utc(true),
    locale: {
        ...dayjsGenerateConfig.locale,
        parse: (locale, text, formats) =>
            dayjsGenerateConfig.locale
                .parse(locale, text, formats)
                ?.utc(true) ?? null,
    },
}

export const UtcDatePicker = generatePicker<Dayjs>(utcGenerateConfig)
